import { render, staticRenderFns } from "./DialogAccountNumber.vue?vue&type=template&id=70b7ff64"
import script from "./DialogAccountNumber.vue?vue&type=script&lang=js"
export * from "./DialogAccountNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports